import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { getAccountDetail, updateCompanyProfile, getHiringStatuses, createHiringStatus, updateHiringStatus, deleteHiringStatus, reorderHiringStatuses } from '../../Redux/ActionCreators/settingAction';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import "./settings.scss";
import { getLanguages, closeInviteModal, getEmailTemplate, previewTemplate, updateEmailTemplate } from '../../Redux/ActionCreators/testLibraryAction';
import { TemplateEditor } from '../../utils/editor';
import { BodyEditor, FooterEditor } from '../../utils/editor';
import { Modal } from 'react-bootstrap';
import { getTanentDomain } from '../../Redux/ActionCreators/layoutAction';
import { setNavigationGuard, clearNavigationGuard } from '../../utils/navigationGuard';

const WHITE_LABEL_COLOUR_PRESETS = [
    ['#434343', '#999999', '#F44336', '#FF9800', '#FFEB3B', '#8BC34A', '#4CAF50', '#26A69A', '#29B6F6', '#7986CB', '#BA68C8', '#F75891'],
    ['#666666', '#B3B3B3', '#E53935', '#FB8C00', '#FDD835', '#7CB342', '#43A047', '#00897B', '#039BE5', '#5C6BC0', '#8E24AA', '#EC407A'],
    ['#212121', '#616161', '#B71C1C', '#E65100', '#F57F17', '#33691E', '#1B5E20', '#004D40', '#01579B', '#283593', '#4A148C', '#AD1457'],
];

const hexToRgb = (hex) => {
    const clean = (hex || '').replace('#', '');
    if (clean.length !== 6) return null;
    const bigint = parseInt(clean, 16);
    if (Number.isNaN(bigint)) return null;
    return { r: (bigint >> 16) & 255, g: (bigint >> 8) & 255, b: bigint & 255 };
}

export default function Accounts() {
    const [lang, setLang] = useState(localStorage.getItem('i18nextLng'))
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [image, setImage] = useState('');
    const [imageName, setImageName] = useState('');
    const [website, setWebsite] = useState('');
    const [update, setUpdate] = useState(false);
    const [successMessageText, setsuccessMessageText] = useState('');
    const [successMsg, setSuccessMsg] = useState(false);
    const [imageError, setImageError] = useState('');
    const [isWhiteLabel, setIsWhiteLabel] = useState(false);
    const [whiteLabelColour, setWhiteLabelColour] = useState('#F75891');
    const [activeTab, setActiveTab] = useState('profile');
    const [reminderEdit, setReminderEdit] = useState(false)
    const [hiringStatusesLocal, setHiringStatusesLocal] = useState([]);
    const [statusOrderDirty, setStatusOrderDirty] = useState(false);
    const [statusLoading, setStatusLoading] = useState(false);
    const [newStatusName, setNewStatusName] = useState('');
    const [newStatusError, setNewStatusError] = useState('');
    const [editingStatusId, setEditingStatusId] = useState(null);
    const [editingStatusName, setEditingStatusName] = useState('');
    const [dragStatusId, setDragStatusId] = useState(null);
    const [deleteConfirm, setDeleteConfirm] = useState({ show: false, id: null, name: '' });
    const [leaveConfirm, setLeaveConfirm] = useState({ show: false, type: null, target: null });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { accountDetail, hiringStatuses } = useSelector(state => state.setting);
    const { languages, templateType, templates, templateText, editTemplate, emailBody, footer, instruction, templateId } = useSelector(state => state.testLibrary);
    const [emailTemplate, setEmailTemplate] = useState('');
    const [isPreview, setIsPreview] = useState(false);
    const [edit, setEdit] = useState(false);
    const [templateLoading, setTemplateLoading] = useState(false);


    useEffect(() => {
        const firstRender = async () => {
            await dispatch(getLanguages());
            const res = await dispatch(getAccountDetail());
            if (res?.type === 'GET_ACCOUNT_DETAIL') {
                setName(res?.payload?.displayName);
                setImage(res?.payload?.logoImage);
                setImageUrl(res?.payload?.logoImage);
                setWebsite(res?.payload.website === null ? '' : res?.payload.website);
                setLang({ languageCode: res.payload.languageCode, label: res.payload.languageName, value: res.payload?.languageId })
                setIsWhiteLabel(!!res?.payload?.isWhiteLabel);
                setWhiteLabelColour(res?.payload?.colour || '#F75891');
            }
        }
        firstRender();
    }, [])

    useEffect(() => {
        setHiringStatusesLocal(Array.isArray(hiringStatuses) ? hiringStatuses.filter(s => s.is_active !== false) : []);
        setStatusOrderDirty(false);
    }, [hiringStatuses])

    // Guard in-app navigation (e.g. Sidebar links) while there's an unsaved status order.
    useEffect(() => {
        if (statusOrderDirty) {
            setNavigationGuard((path) => setLeaveConfirm({ show: true, type: 'route', target: path }));
        } else {
            clearNavigationGuard();
        }
        return () => clearNavigationGuard();
    }, [statusOrderDirty])

    // Guard tab close / refresh / typing a new URL while there's an unsaved status order.
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (!statusOrderDirty) return;
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [statusOrderDirty])

    const loadHiringStatuses = async () => {
        setStatusLoading(true);
        await dispatch(getHiringStatuses());
        setStatusLoading(false);
    }




    const changeCampusName = (val) => {
        setName(val)
        setNameError('')
    }

    const changeImage = (e) => {
        if (e.target.files[0].size > 2097152) {
            setSuccessMsg(true);
            setsuccessMessageText(t("The file size cannot exceed 2MB"))
        }
        else {
            const file = e.target.files[0]
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageUrl(reader.result);
            }
            if (file) {
                reader.readAsDataURL(file);
                setImageUrl(reader.result);
                setImageName(file.name);
                setImage(file)
                setUpdate(true)
            }
            else {
                setImageUrl('');
                setImageName('');
                setUpdate(false);
            }
        }

    }

    const editCompany = async () => {
        if (name === "") {
            setNameError(t('Please enter Company name'))

        } else if (image === '') {
            setImageError(t('Please upload image for logo'))
        }
        else {
            let data
            if (update) {
                data = {
                    name: name,
                    website: website,
                    image: image,
                    tenantId: accountDetail?.tenantID,
                    languageId: lang.value,
                    isWhiteLabel: isWhiteLabel,
                    colour: whiteLabelColour
                }
                await dispatch(updateCompanyProfile(data));
                await dispatch(getTanentDomain(window.location.host));
                setSuccessMsg(true);
                setsuccessMessageText(t("Company Profile has been successfully updated"))
            }
            else {
                data = {
                    name: name,
                    website: website,
                    tenantId: accountDetail?.tenantID,
                    languageId: lang.value,
                    isWhiteLabel: isWhiteLabel,
                    colour: whiteLabelColour
                }
                await dispatch(updateCompanyProfile(data));
                setSuccessMsg(true);
                setsuccessMessageText(t("Company Profile has been successfully updated"))
            }
        }
    }

    const handleChangeLanguage = async (e) => {
        console.log(e)
        await setLang(e);
        i18n.changeLanguage(e.languageCode);
        let data = {
            name: name,
            website: website,
            tenantId: accountDetail?.tenantID,
            languageId: e.value
        }
        await dispatch(updateCompanyProfile(data));
        localStorage.setItem("i18nextLng", e.languageCode);
        setSuccessMsg(true);
        setsuccessMessageText(t("Company Profile has been successfully updated"))
    }

    const switchTab = async (e) => {
        setActiveTab(e)
        if (e === 'profile') {
            const res = await dispatch(getAccountDetail());
            if (res?.type === 'GET_ACCOUNT_DETAIL') {
                setName(res?.payload?.displayName);
                setImage(res?.payload?.logoImage);
                setImageUrl(res?.payload?.logoImage);
                setWebsite(res?.payload.website === null ? '' : res?.payload.website);
                setLang({ languageCode: res.payload.languageCode, label: res.payload.languageName, value: res.payload?.languageId })
                setIsWhiteLabel(!!res?.payload?.isWhiteLabel);
                setWhiteLabelColour(res?.payload?.colour || '#F75891');
            }
        } else if (e === 'hiringStatuses') {
            await loadHiringStatuses();
        } else if (e === 'invitation') {
            setTemplateLoading(true);
            await dispatch(getEmailTemplate(1, false));
            setTemplateLoading(false);
        } else {
            setTemplateLoading(true);
            await dispatch(getEmailTemplate(2, false));
            setTemplateLoading(false);
        }
    }

    const onHandleChange = async (e) => {
        if (activeTab === 'hiringStatuses' && statusOrderDirty && e !== activeTab) {
            setLeaveConfirm({ show: true, type: 'tab', target: e });
            return;
        }
        await switchTab(e);
    }

    const closeLeaveConfirm = () => setLeaveConfirm({ show: false, type: null, target: null });

    const handleLeaveSaveAndGo = async () => {
        const { type, target } = leaveConfirm;
        await handleSaveStatusOrder();
        closeLeaveConfirm();
        if (type === 'route') navigate(target);
        else if (type === 'tab') await switchTab(target);
    }

    const handleLeaveDiscardAndGo = async () => {
        const { type, target } = leaveConfirm;
        setHiringStatusesLocal(Array.isArray(hiringStatuses) ? hiringStatuses.filter(s => s.is_active !== false) : []);
        setStatusOrderDirty(false);
        closeLeaveConfirm();
        if (type === 'route') navigate(target);
        else if (type === 'tab') await switchTab(target);
    }

    const snackClosed = () => {
        setSuccessMsg(false);
        setsuccessMessageText('');
    }

    const handleCreateStatus = async () => {
        const value = newStatusName.trim();
        if (!value) {
            setNewStatusError(t('Please enter a status name', { ns: 'profile' }));
            return;
        }
        await dispatch(createHiringStatus(value));
        setNewStatusName('');
        setNewStatusError('');
        await loadHiringStatuses();
        setSuccessMsg(true);
        setsuccessMessageText(t('Hiring status created', { ns: 'profile' }));
    }

    const startEditStatus = (status) => {
        setEditingStatusId(status.id);
        setEditingStatusName(status.name);
    }

    const cancelEditStatus = () => {
        setEditingStatusId(null);
        setEditingStatusName('');
    }

    const saveEditStatus = async (id) => {
        const value = editingStatusName.trim();
        if (!value) return;
        await dispatch(updateHiringStatus(id, value));
        cancelEditStatus();
        await loadHiringStatuses();
        setSuccessMsg(true);
        setsuccessMessageText(t('Hiring status updated', { ns: 'profile' }));
    }

    const handleDeleteStatus = (id, statusName) => {
        setDeleteConfirm({ show: true, id, name: statusName });
    }

    const closeDeleteConfirm = () => {
        setDeleteConfirm({ show: false, id: null, name: '' });
    }

    const confirmDeleteStatus = async () => {
        const { id } = deleteConfirm;
        closeDeleteConfirm();
        await dispatch(deleteHiringStatus(id));
        await loadHiringStatuses();
        setSuccessMsg(true);
        setsuccessMessageText(t('Hiring status deactivated', { ns: 'profile' }));
    }

    const moveStatus = (index, delta) => {
        const next = index + delta;
        if (next < 0 || next >= hiringStatusesLocal.length) return;
        const reordered = hiringStatusesLocal.slice();
        const tmp = reordered[index];
        reordered[index] = reordered[next];
        reordered[next] = tmp;
        setHiringStatusesLocal(reordered);
        setStatusOrderDirty(true);
    }

    const handleStatusDragStart = (id) => {
        setDragStatusId(id);
    }

    const handleStatusDrop = (targetId) => {
        if (!dragStatusId || dragStatusId === targetId) return;
        const from = hiringStatusesLocal.findIndex((x) => x.id === dragStatusId);
        const to = hiringStatusesLocal.findIndex((x) => x.id === targetId);
        if (from < 0 || to < 0) return;
        const reordered = hiringStatusesLocal.slice();
        const [item] = reordered.splice(from, 1);
        reordered.splice(to, 0, item);
        setHiringStatusesLocal(reordered);
        setStatusOrderDirty(true);
        setDragStatusId(null);
    }

    const handleSaveStatusOrder = async () => {
        const ordered_ids = hiringStatusesLocal.map((s) => s.id);
        await dispatch(reorderHiringStatuses(ordered_ids));
        await loadHiringStatuses();
        setSuccessMsg(true);
        setsuccessMessageText(t('Hiring status order saved', { ns: 'profile' }));
    }


    const openPreview = async () => {
        await setIsPreview(true)
        await dispatch(previewTemplate())
    }
    const saveTemplate = async () => {

        let obj = {
            "templateId": templateId,
            "template": templates,
            EmailBody: emailBody,
            footer: footer,
            additionalInstruction: instruction
        }
        const res = await dispatch(updateEmailTemplate(obj));
        if (res?.type === 'UPDATE_TEMPLATE') {
            await dispatch(getEmailTemplate(templateType, false));
            setEdit(false);
            !edit && await dispatch(closeInviteModal());
        }
    }

    const whiteLabelRgb = hexToRgb(whiteLabelColour);

    return (
        <div className='profile-page'>
            <div className='account-tabs'>
                <button className={activeTab === 'profile' ? 'active' : ''} onClick={() => onHandleChange('profile')}>{t('Account Details', { ns: 'profile' })}</button>&nbsp;&nbsp;
                <button className={activeTab === 'hiringStatuses' ? 'active' : ''} onClick={() => onHandleChange('hiringStatuses')}>{t('Hiring Statuses', { ns: 'profile' })}</button>&nbsp;&nbsp;
                <button className={activeTab === 'invitation' ? 'active' : ''} onClick={() => onHandleChange('invitation')}>{t('Invitation Template', { ns: 'profile' })}</button>&nbsp;&nbsp;
                <button className={activeTab === 'reminder' ? 'active' : ''} onClick={() => onHandleChange('reminder')}>{t('Reminder Template', { ns: 'profile' })}</button>
            </div>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={successMsg}
                onClose={snackClosed}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="success" sx={{ width: '100%' }}>
                    {successMessageText}
                </Alert>
            </Snackbar>

            {activeTab === 'profile' ?
                <div className='account-holder row'>
                    <h3 className='d-flex justify-content-between align-items-center'>{t('Account Details', { ns: 'profile' })}
                        <div className='d-flex  align-items-center' style={{ width: '30%' }} >
                            <p style={{ fontSize: 12, width: '60%' }}> {t('App Language', { ns: 'profile' })}</p>&nbsp;
                            <Select className='form-control select-input'
                                value={lang}
                                onChange={handleChangeLanguage}
                                placeholder='Select Language'
                                options={languages?.map(el => [{ ...el, label: el.languageName, value: el.languageId }][0])} />
                        </div></h3>
                    <div id="google_translate_element"></div>
                    {/* <p>Update account details. Personal profile details can be updated in the profile section.</p> */}
                    <p className='warn-text mt-2'>{t('Fields marked * are mandatory', { ns: 'profile' })}</p>
                    <div className='col-md-5'>
                        <div className='form-group mt-3'>
                            <label>{t('Company Name', { ns: 'profile' })}*
                            </label>
                            <input className='form-control mt-2' value={name} onChange={(e) => changeCampusName(e.target.value)} pattern="[A-Za-z]" />
                            {nameError}
                        </div>
                        <div className='form-group mt-4'>
                            <label>{t('Website(Optional)', { ns: "profile" })}
                            </label>
                            <input className='form-control mt-2' value={website} onChange={(e) => setWebsite(e.target.value)} />
                        </div>
                    </div>
                    <div className='col-md-6 offset-md-1'>
                        <div className='white-label-toggle-row d-flex align-items-center justify-content-between'>
                            <div className='white-label-toggle-text'>
                                <label>{t('WhiteLabel', { ns: 'profile' })}</label>
                                <span>{t('Use your own brand colour across the app', { ns: 'profile' })}</span>
                            </div>
                            <label className='white-label-switch'>
                                <input
                                    type='checkbox'
                                    checked={isWhiteLabel}
                                    onChange={(e) => setIsWhiteLabel(e.target.checked)}
                                />
                                <span className='white-label-slider'></span>
                            </label>
                        </div>
                        <div className='mt-3'>
                            <label>{t('Company Logo', { ns: 'profile' })}*</label>
                            <div className='d-flex align-items-center '>
                                {
                                    image ?
                                        <div className='program-image'>
                                            <img src={imageUrl} alt='' width='139px' height='78px' />
                                        </div> :
                                        <div className='program-image'>
                                            <img src={imageUrl} alt='' />
                                        </div>
                                }

                                <div className='d-flex flex-column mt-3 position-relative'>
                                    <span> <img src='/images/upload-icon-pink.svg' alt='' /> &nbsp;{t('Upload Image', { ns: 'profile' })} &nbsp; <small>{imageName}</small>
                                        <input type='file' className='file-upload'
                                            name="selectedFile" accept="image/png, image/jpeg" onChange={changeImage} />
                                    </span>
                                </div>
                            </div>
                            {imageError}
                        </div>
                        {isWhiteLabel ?
                            <div className='mt-3 white-label-colour'>
                                <label>{t('Custom Colour', { ns: 'profile' })}</label>
                                <div className='colour-palette mt-2'>
                                    {WHITE_LABEL_COLOUR_PRESETS.map((row, rowIdx) => (
                                        <div className='colour-palette-row' key={rowIdx}>
                                            {row.map((hex) => (
                                                <button
                                                    type='button'
                                                    key={hex}
                                                    className={`colour-swatch${whiteLabelColour?.toUpperCase() === hex ? ' is-selected' : ''}`}
                                                    style={{ backgroundColor: hex }}
                                                    title={hex}
                                                    onClick={() => setWhiteLabelColour(hex)}
                                                />
                                            ))}
                                        </div>
                                    ))}
                                </div>
                                <div className='colour-selected d-flex align-items-center mt-2'>
                                    <input
                                        type='color'
                                        className='white-label-colour-swatch'
                                        value={whiteLabelColour}
                                        onChange={(e) => setWhiteLabelColour(e.target.value)}
                                    />
                                    <span className='colour-hex ms-2'>{whiteLabelColour?.toUpperCase()}</span>
                                    {whiteLabelRgb ?
                                        <span className='colour-rgb ms-3'>
                                            R <b>{whiteLabelRgb.r}</b> &nbsp; G <b>{whiteLabelRgb.g}</b> &nbsp; B <b>{whiteLabelRgb.b}</b>
                                        </span>
                                        : null}
                                    <input
                                        type='text'
                                        className='form-control ms-3'
                                        value={whiteLabelColour}
                                        onChange={(e) => setWhiteLabelColour(e.target.value)}
                                        maxLength={7}
                                    />
                                </div>
                            </div>
                            : null}
                    </div>
                    <hr style={{ marginTop: 15 }} />
                    <div className='save-btn'>
                        <button onClick={editCompany}>{t('Save Changes', { ns: 'profile' })}</button>
                        {/* <button onClick={(handleModal)}>Cancel</button> */}
                    </div>
                </div>
                : null
            }
            {activeTab === 'hiringStatuses' ?
                <div className='hs-holder'>
                    <div className='hs-header'>
                        <div>
                            <h3>{t('Hiring Statuses', { ns: 'profile' })}</h3>
                            <p className='warn-text'>{t('Default statuses cannot be renamed or removed. Drag the grip or use the arrows to reorder.', { ns: 'profile' })}</p>
                        </div>
                        <button
                            type='button'
                            className='hs-save-order-btn'
                            disabled={!statusOrderDirty}
                            onClick={handleSaveStatusOrder}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                            {t('Save Order', { ns: 'profile' })}
                        </button>
                    </div>

                    <div className='hs-create-box'>
                        <input
                            className='form-control'
                            maxLength={256}
                            placeholder={t('Create a custom status, e.g. Interview Pending', { ns: 'profile' })}
                            value={newStatusName}
                            onChange={(e) => { setNewStatusName(e.target.value); setNewStatusError(''); }}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleCreateStatus(); }}
                        />
                        <button type='button' className='hs-create-btn' onClick={handleCreateStatus}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
                            {t('Create', { ns: 'profile' })}
                        </button>
                    </div>
                    {newStatusError ? <p className='error-text'>{newStatusError}</p> : null}

                    {statusLoading ?
                        <div className="loading-overlay" style={{ alignItems: "start", color: "#F75891", height: "auto" }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        :
                        <ul className='hs-list'>
                            {hiringStatusesLocal.length === 0 ?
                                <li className='hs-empty'>{t('No hiring statuses found.', { ns: 'profile' })}</li>
                                :
                                hiringStatusesLocal.map((s, index) => (
                                    <li
                                        key={s.id}
                                        className={`hs-item ${s.type === 'default' ? 'is-default' : 'is-custom'} ${dragStatusId === s.id ? 'is-dragging' : ''}`}
                                        draggable
                                        onDragStart={() => handleStatusDragStart(s.id)}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={() => handleStatusDrop(s.id)}
                                    >
                                        <span className='hs-grip' title={t('Drag to reorder', { ns: 'profile' })}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><circle cx="9" cy="6" r="1.6"/><circle cx="15" cy="6" r="1.6"/><circle cx="9" cy="12" r="1.6"/><circle cx="15" cy="12" r="1.6"/><circle cx="9" cy="18" r="1.6"/><circle cx="15" cy="18" r="1.6"/></svg>
                                        </span>
                                        <div className='hs-body'>
                                            {editingStatusId === s.id ?
                                                <input
                                                    className='form-control'
                                                    value={editingStatusName}
                                                    onChange={(e) => setEditingStatusName(e.target.value)}
                                                    onKeyDown={(e) => { if (e.key === 'Enter') saveEditStatus(s.id); }}
                                                    autoFocus
                                                />
                                                :
                                                <span className='hs-name'>
                                                    {s.name}
                                                    <span className={`hs-badge ${s.type === 'default' ? 'hs-badge--default' : 'hs-badge--custom'}`}>
                                                        {s.type === 'default' ? t('default', { ns: 'profile' }) : t('custom', { ns: 'profile' })}
                                                    </span>
                                                </span>
                                            }
                                        </div>
                                        <div className='hs-actions'>
                                            <button type='button' className='hs-qa-btn' disabled={index === 0} onClick={() => moveStatus(index, -1)} title={t('Move up', { ns: 'profile' })}>
                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><polyline points="18 15 12 9 6 15" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                            </button>
                                            <button type='button' className='hs-qa-btn' disabled={index === hiringStatusesLocal.length - 1} onClick={() => moveStatus(index, 1)} title={t('Move down', { ns: 'profile' })}>
                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><polyline points="6 9 12 15 18 9" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                            </button>
                                            {s.type === 'custom' ?
                                                editingStatusId === s.id ?
                                                    <>
                                                        <button type='button' className='hs-qa-btn hs-qa-btn--save' onClick={() => saveEditStatus(s.id)} title={t('Save', { ns: 'profile' })}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                        </button>
                                                        <button type='button' className='hs-qa-btn hs-qa-btn--close' onClick={cancelEditStatus} title={t('Cancel', { ns: 'profile' })}>
                                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
                                                        </button>
                                                    </>
                                                    :
                                                    <>
                                                        <button type='button' className='hs-qa-btn' onClick={() => startEditStatus(s)} title={t('Edit', { ns: 'profile' })}>
                                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                                        </button>
                                                        <button type='button' className='hs-qa-btn hs-qa-btn--close' onClick={() => handleDeleteStatus(s.id, s.name)} title={t('Delete', { ns: 'profile' })}>
                                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                                        </button>
                                                    </>
                                                : null
                                            }
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    }
                </div>
                : null
            }
            {activeTab === 'invitation' ?
                <div>
                    <div className='account-holder'>
                        {templateLoading ?
                            <div className="loading-overlay" style={{ alignItems: "start", color: "#F75891", height: "auto" }}>
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            :
                        <>
                            <div>
                                <div dangerouslySetInnerHTML={{ __html: emailTemplate }} />
                                <div className='template-details'>
                                    <div className='template-header'>
                                        {(editTemplate || edit) ? <img className='cursor-pointer' src='/images/back.svg' onClick={() => {
                                            setEdit(false)
                                            dispatch(closeInviteModal())
                                        }} alt='' /> : null}
                                        <h4>{(editTemplate || edit) ? 'Edit Template' : ''}</h4>
                                        {editTemplate ?
                                            <button onClick={saveTemplate}>{t('Save', { ns: 'home' })}</button> :
                                            (edit) ?
                                                <button onClick={saveTemplate}>{t('Save', { ns: 'home' })}</button> :
                                                <button onClick={() => {
                                                    setEdit(true)
                                                }}>{t('Edit', { ns: 'home' })}</button>
                                        }
                                    </div>
                                    <div className='template-desc d-flex flex-column align-items-center'>
                                        <div className='template-image text-center w-100'>
                                            <img src='/images/editor-img.svg' alt='' width={(!editTemplate && !edit) ? 594 : '75%'} />
                                            <div className='template-text'>
                                                <h3>GAPPEO</h3>
                                                <p style={{ color: "#FFF" }}>{t('Skill Test Platform', { ns: 'home' })} </p>
                                            </div>
                                        </div>
                                        {editTemplate ?
                                            <div style={{ width: '75%' }}>
                                                <TemplateEditor content={instruction} type='template' />
                                            </div> :
                                            edit ?
                                                <div style={{ width: '75%' }}>
                                                    <div className='d-flex justify-content-end mt-2'>
                                                        <button className='preview-btn' onClick={() => openPreview()}>Preview</button>
                                                    </div>
                                                    <div className='form-group mt-2'>
                                                        <label>Email Body</label>
                                                        <BodyEditor content={emailBody} type='email' />
                                                    </div>
                                                    <div className='form-group mt-2'>
                                                        <label>Signature</label>
                                                        <FooterEditor content={footer} type='footer' />
                                                    </div>

                                                </div>
                                                :
                                                <div dangerouslySetInnerHTML={{ __html: templates }} />
                                        }
                                    </div>

                                </div >
                            </div>
                        </>
                        }
                    </div>
                </div>
                : null
            }
            {activeTab === 'reminder' ?
                <div className='account-holder'>
                    {templateLoading ?
                        <div className="loading-overlay" style={{ alignItems: "start", color: "#F75891", height: "auto" }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        :
                    <>
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: emailTemplate }} />
                            <div className='template-details'>
                                <div className='template-header'>
                                    {(editTemplate || edit) ? <img className='cursor-pointer' src='/images/back.svg' onClick={() => {
                                        setEdit(false)
                                        dispatch(closeInviteModal())
                                    }} alt='' /> : null}
                                    <h4>{(editTemplate || edit) ? 'Edit Template' : ''}</h4>
                                    {editTemplate ?
                                        <button onClick={saveTemplate}>{t('Save', { ns: 'home' })}</button> :
                                        (edit) ?
                                            <button onClick={saveTemplate}>{t('Save', { ns: 'home' })}</button> :
                                            <button onClick={() => {
                                                setEdit(true)
                                            }}>{t('Edit', { ns: 'home' })}</button>
                                    }
                                </div>
                                <div className='template-desc d-flex flex-column align-items-center'>
                                    <div className='template-image text-center w-100'>
                                        <img src='/images/editor-img.svg' alt='' width={(!editTemplate && !edit) ? 594 : '75%'} />
                                        <div className='template-text'>
                                            <h3>GAPPEO</h3>
                                            <p style={{ color: "#FFF" }}>{t('Skill Test Platform', { ns: 'home' })} </p>
                                        </div>
                                    </div>
                                    {editTemplate ?
                                        <div style={{ width: '75%' }}>
                                            <TemplateEditor content={instruction} type='template' />
                                        </div> :
                                        edit ?
                                            <div style={{ width: '75%' }}>
                                                <div className='d-flex justify-content-end mt-2'>
                                                    <button className='preview-btn' onClick={() => openPreview()}>Preview</button>
                                                </div>
                                                <div className='form-group mt-2'>
                                                    <label>Email Body</label>
                                                    <BodyEditor content={emailBody} type='email' />
                                                </div>
                                                <div className='form-group mt-2'>
                                                    <label>Signature</label>
                                                    <FooterEditor content={footer} type='footer' />
                                                </div>

                                            </div>
                                            :
                                            <div dangerouslySetInnerHTML={{ __html: templates }} />
                                    }
                                </div>

                            </div >
                        </div>
                    </>
                    }
                </div>
                : null
            }

            <Modal
                show={isPreview}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                // onHide={this.handleCloseModal}
                dialogClassName={"preview-modal"}
            >
                <div className='sticky-close'>
                    <img src='/images/close.svg' alt='' onClick={() => setIsPreview(false)} />
                </div>
                <div className="p-4" >
                    <div dangerouslySetInnerHTML={{ __html: templateText }} />
                </div>
            </Modal>

            <Modal
                show={deleteConfirm.show}
                onHide={closeDeleteConfirm}
                centered
                dialogClassName={"delete-status-modal"}
            >
                <div className="p-4">
                    <h4>{t('Deactivate hiring status', { ns: 'profile' })}</h4>
                    <p className="mt-2">
                        {t('Are you sure you want to deactivate', { ns: 'profile' })} "<strong>{deleteConfirm.name}</strong>"? {t('This status will no longer be available for use.', { ns: 'profile' })}
                    </p>
                    <div className="d-flex justify-content-end mt-4" style={{ gap: 10 }}>
                        <button type="button" className="btn-cancel-delete" onClick={closeDeleteConfirm}>
                            {t('Cancel', { ns: 'profile' })}
                        </button>
                        <button type="button" className="btn-confirm-delete" onClick={confirmDeleteStatus}>
                            {t('Deactivate', { ns: 'profile' })}
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                show={leaveConfirm.show}
                onHide={closeLeaveConfirm}
                centered
                dialogClassName={"delete-status-modal"}
            >
                <div className="p-4">
                    <h4>{t('Unsaved status order', { ns: 'profile' })}</h4>
                    <p className="mt-2">
                        {t("You've reordered hiring statuses but haven't saved yet. Save your changes before leaving?", { ns: 'profile' })}
                    </p>
                    <div className="d-flex justify-content-end mt-4" style={{ gap: 10 }}>
                        <button type="button" className="btn-cancel-delete" onClick={closeLeaveConfirm}>
                            {t('Stay on page', { ns: 'profile' })}
                        </button>
                        <button type="button" className="btn-cancel-delete" onClick={handleLeaveDiscardAndGo}>
                            {t('Discard & leave', { ns: 'profile' })}
                        </button>
                        <button type="button" className="hs-save-order-btn" onClick={handleLeaveSaveAndGo}>
                            {t('Save order & leave', { ns: 'profile' })}
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
